"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskySlider = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const StyledContainer = (0, material_1.styled)("div")({
  width: 300
});
const StyledSlider = (0, material_1.styled)(material_1.Slider)({
  padding: "22px 0px"
});

const SskySlider = props => {
  var _a, _b;

  return react_1.default.createElement(StyledContainer, {
    className: props.className
  }, react_1.default.createElement(StyledSlider, {
    value: props.value,
    min: props.min,
    max: props.max,
    step: props.step,
    onChange: props.onChange,
    onChangeCommitted: props.onChangeCommitted,
    disabled: props.disabled,
    "aria-labelledby": "slider",
    "data-testid": props.dataTestId,
    marks: props.marks,
    valueLabelDisplay: (_a = props.valueLabelDisplay) !== null && _a !== void 0 ? _a : "off",
    valueLabelFormat: props.valueLabelFormat,
    size: (_b = props.size) !== null && _b !== void 0 ? _b : "medium"
  }));
};

exports.SskySlider = SskySlider;
SskySlider.defaultProps = {
  disabled: false,
  min: 0,
  max: 100,
  step: 1 // conforms values to integers. for decimals replace step value with 0.

};
exports.default = react_1.default.memo(SskySlider);